import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

interface Training {
  id: string;
  title: string;
  subtitle: string;
  duration: string;
  format: string;
  level: string;
  modules: number;
  price: string;
  description: string;
  topics: string[];
  image: string;
}

const trainings: Training[] = [
  {
    id: 'temel-astroloji',
    title: 'Temel Astroloji Eğitimi',
    subtitle: 'Astrolojiye Giriş ve Temel Kavramlar',
    duration: '12 Hafta',
    format: 'Online Canlı',
    level: 'Başlangıç',
    modules: 12,
    price: '8.500 TL',
    description: 'Astrolojinin temel prensiplerini, gezegenleri, burçları ve evleri öğrenerek kendi doğum haritanızı okumaya başlayın.',
    topics: [
      'Astroloji Tarihi ve Felsefesi',
      '12 Burç ve Özellikleri',
      'Gezegenler ve Anlamları',
      '12 Ev Sistemi',
      'Açılar ve Aspektler',
      'Doğum Haritası Okuma Temelleri'
    ],
    image: 'https://public.readdy.ai/ai/img_res/d730dbca2e0b27c706f8e37215cef6d0.jpg'
  },
  {
    id: 'ileri-harita-okuma',
    title: 'İleri Seviye Harita Okuma',
    subtitle: 'Derinlemesine Analiz ve Yorum Teknikleri',
    duration: '16 Hafta',
    format: 'Online Canlı',
    level: 'İleri',
    modules: 16,
    price: '12.000 TL',
    description: 'Doğum haritalarını profesyonel seviyede analiz etmeyi, transit ve progresyonları yorumlamayı öğrenin.',
    topics: [
      'İleri Seviye Aspekt Yorumlama',
      'Transit ve Progresyonlar',
      'Sinastri ve İlişki Analizi',
      'Vokasyonel Astroloji',
      'Karmik Astroloji',
      'Profesyonel Danışmanlık Teknikleri'
    ],
    image: 'https://readdy.ai/api/search-image?query=advanced%20astrology%20study%20with%20detailed%20birth%20charts%20planetary%20transits%20diagrams%20and%20cosmic%20calculations%20sophisticated%20workspace%20with%20golden%20accents%20deep%20navy%20background%20professional%20astrological%20tools%20and%20reference%20materials%20mystical%20atmosphere&width=800&height=600&seq=train2&orientation=landscape'
  },
  {
    id: 'enerji-frekans',
    title: 'Enerji ve Frekans Çalışmaları',
    subtitle: 'Şifa ve Enerji Yönetimi Eğitimi',
    duration: '10 Hafta',
    format: 'Online Canlı',
    level: 'Tüm Seviyeler',
    modules: 10,
    price: '7.500 TL',
    description: 'Enerji alanınızı tanıyın, şifa tekniklerini öğrenin ve frekans çalışmalarıyla kendinizi dönüştürün.',
    topics: [
      'Enerji Anatomisi ve Çakralar',
      'Aura Okuma ve Temizleme',
      'Kristal Şifa Teknikleri',
      'Frekans ve Titreşim Çalışmaları',
      'Enerji Koruması',
      'Uzaktan Şifa Uygulamaları'
    ],
    image: 'https://readdy.ai/api/search-image?query=energy%20healing%20training%20scene%20with%20crystals%20chakra%20symbols%20and%20glowing%20aura%20visualization%20serene%20meditation%20space%20with%20golden%20light%20rays%20navy%20blue%20ambient%20background%20spiritual%20healing%20tools%20and%20sacred%20geometry%20peaceful%20atmosphere&width=800&height=600&seq=train3&orientation=landscape'
  },
  {
    id: 'spiritual-gelisim',
    title: 'Spiritüel Gelişim Atölyesi',
    subtitle: 'İç Yolculuk ve Bilinç Genişletme',
    duration: '8 Hafta',
    format: 'Online Canlı',
    level: 'Tüm Seviyeler',
    modules: 8,
    price: '6.000 TL',
    description: 'Spiritüel farkındalığınızı artırın, içsel rehberliğinize bağlanın ve yaşam amacınızı keşfedin.',
    topics: [
      'Meditasyon ve Farkındalık',
      'İçsel Rehberlik ve Sezgi',
      'Yaşam Amacı Keşfi',
      'Gölge Çalışması',
      'Manifestasyon Teknikleri',
      'Spiritüel Günlük Pratikler'
    ],
    image: 'https://readdy.ai/api/search-image?query=spiritual%20development%20workshop%20with%20meditation%20space%20sacred%20symbols%20and%20consciousness%20expansion%20imagery%20tranquil%20setting%20with%20warm%20golden%20glow%20deep%20navy%20tones%20spiritual%20growth%20elements%20and%20enlightenment%20symbols%20peaceful%20journey&width=800&height=600&seq=train4&orientation=landscape'
  },
  {
    id: 'numeroloji',
    title: 'Numeroloji ve Yaşam Yolu',
    subtitle: 'Sayıların Gizli Dili',
    duration: '6 Hafta',
    format: 'Online Canlı',
    level: 'Başlangıç',
    modules: 6,
    price: '5.500 TL',
    description: 'Sayıların spiritüel anlamlarını keşfedin, yaşam yolu numaranızı ve kişisel döngülerinizi öğrenin.',
    topics: [
      'Numeroloji Temelleri',
      'Yaşam Yolu Sayısı',
      'Kader ve Kişilik Sayıları',
      'İsim Analizi',
      'Kişisel Yıl Döngüleri',
      'Uyumluluk Analizi'
    ],
    image: 'https://readdy.ai/api/search-image?query=numerology%20education%20scene%20with%20mystical%20numbers%20sacred%20geometry%20and%20mathematical%20symbols%20elegant%20study%20space%20with%20golden%20numbers%20floating%20navy%20blue%20cosmic%20background%20spiritual%20mathematics%20and%20life%20path%20calculations%20wisdom&width=800&height=600&seq=train6&orientation=landscape'
  }
];

export default function EgitimlerPage() {
  const [selectedLevel, setSelectedLevel] = useState<string>('all');

  const filteredTrainings = selectedLevel === 'all' 
    ? trainings 
    : trainings.filter(t => t.level === selectedLevel);

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-navy/5 to-gold/5"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-primary-dark mb-6">
              Eğitim Programları
            </h1>
            <p className="text-lg text-text-secondary leading-relaxed">
              Astroloji, enerji çalışmaları ve spiritüel gelişim alanlarında profesyonel eğitimlerle 
              kendinizi geliştirin, bilginizi derinleştirin.
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="flex flex-wrap items-center justify-center gap-3 mt-12">
            <button
              onClick={() => setSelectedLevel('all')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                selectedLevel === 'all'
                  ? 'bg-gold text-primary-dark shadow-lg shadow-gold/30'
                  : 'bg-white text-text-secondary border border-gold/30 hover:border-gold'
              }`}
            >
              Tüm Eğitimler
            </button>
            <button
              onClick={() => setSelectedLevel('Başlangıç')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                selectedLevel === 'Başlangıç'
                  ? 'bg-gold text-primary-dark shadow-lg shadow-gold/30'
                  : 'bg-white text-text-secondary border border-gold/30 hover:border-gold'
              }`}
            >
              Başlangıç
            </button>
            <button
              onClick={() => setSelectedLevel('İleri')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                selectedLevel === 'İleri'
                  ? 'bg-gold text-primary-dark shadow-lg shadow-gold/30'
                  : 'bg-white text-text-secondary border border-gold/30 hover:border-gold'
              }`}
            >
              İleri Seviye
            </button>
            <button
              onClick={() => setSelectedLevel('Tüm Seviyeler')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                selectedLevel === 'Tüm Seviyeler'
                  ? 'bg-gold text-primary-dark shadow-lg shadow-gold/30'
                  : 'bg-white text-text-secondary border border-gold/30 hover:border-gold'
              }`}
            >
              Tüm Seviyeler
            </button>
          </div>
        </div>
      </section>

      {/* Trainings Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredTrainings.map((training) => (
              <div
                key={training.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 group"
              >
                <div className="relative h-56 w-full overflow-hidden">
                  <img
                    src={training.image}
                    alt={training.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute top-4 right-4 bg-gold text-primary-dark px-4 py-1.5 rounded-full text-xs font-bold">
                    {training.level}
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="font-serif text-2xl font-bold text-primary-dark mb-2">
                    {training.title}
                  </h3>
                  <p className="text-sm text-gold mb-4 italic">{training.subtitle}</p>

                  <div className="flex flex-wrap gap-3 mb-4">
                    <div className="flex items-center text-xs text-text-secondary">
                      <i className="ri-time-line text-gold mr-1.5"></i>
                      {training.duration}
                    </div>
                    <div className="flex items-center text-xs text-text-secondary">
                      <i className="ri-computer-line text-gold mr-1.5"></i>
                      {training.format}
                    </div>
                    <div className="flex items-center text-xs text-text-secondary">
                      <i className="ri-book-line text-gold mr-1.5"></i>
                      {training.modules} Modül
                    </div>
                  </div>

                  <p className="text-sm text-text-secondary leading-relaxed mb-4">
                    {training.description}
                  </p>

                  <div className="border-t border-gold/20 pt-4 mb-4">
                    <p className="text-xs text-text-secondary mb-2 font-medium">Eğitim İçeriği:</p>
                    <ul className="space-y-1">
                      {training.topics.slice(0, 3).map((topic, idx) => (
                        <li key={idx} className="text-xs text-text-secondary flex items-start">
                          <i className="ri-checkbox-circle-fill text-gold mr-2 mt-0.5 flex-shrink-0"></i>
                          <span>{topic}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-gold/20">
                    <div>
                      <p className="text-xs text-text-secondary">Eğitim Ücreti</p>
                      <p className="text-2xl font-bold text-gold">{training.price}</p>
                    </div>
                    <Link
                      to={`/egitimler/${training.id}`}
                      className="px-6 py-2.5 bg-primary-navy text-white rounded-full text-sm font-medium hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer whitespace-nowrap"
                    >
                      Detaylar
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-primary-navy to-primary-dark">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6">
            Eğitim Hakkında Sorularınız mı Var?
          </h2>
          <p className="text-lg text-text-light mb-8 leading-relaxed">
            Size en uygun eğitim programını birlikte belirleyelim. Ücretsiz ön görüşme için iletişime geçin.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/iletisim"
              className="px-8 py-4 bg-gold text-primary-dark rounded-full font-medium hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              İletişime Geç
            </Link>
            <a
              href="https://wa.me/905555555555"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-8 py-4 bg-white/10 text-white border border-white/30 rounded-full font-medium hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}